'use strict';

const translations = {
    "cable_car": "Téléphérique",
    "chair_lift": "Télésiège",
    "drag_lift": "Téléski",
    "gondola": "Télécabine",
    "platter": "Monte-plat",
    "pylon": "Pylône",
    "station": "Gare de télécabine",
    "t-bar": "Monte-barre en T",
    "aerodrome": "Aérodrome",
    "airstrip": "Piste d’atterrissage",
    "apron": "Aire de stationnement",
    "gate": "Porte",
    "hangar": "Hangar aéronautique",
    "helipad": "Héliport",
    "holding_position": "Position d’attente",
    "parking_position": "Place de parking",
    "runway": "Piste",
    "taxiway": "Piste de circulation d’un aéroport",
    "terminal": "Terminal",
    "animal_shelter": "Refuge pour animaux",
    "arts_centre": "Centre artistique",
    "atm": "Distributeur automatique de billets",
    "bank": "Banque",
    "bar": "Bar",
    "bbq": "Barbecue",
    "bench": "Banc",
    "bicycle_parking": "Parking à vélos",
    "bicycle_rental": "Location de vélos",
    "biergarten": "Brasserie en plein air",
    "boat_rental": "Location de bateaux",
    "brothel": "Bordel",
    "bureau_de_change": "Bureau de change",
    "bus_station": "Arrêt de bus",
    "cafe": "Café",
    "car_rental": "Location de voiture",
    "car_sharing": "Covoiturage",
    "car_wash": "Lavage de voiture",
    "casino": "Casino",
    "charging_station": "Station de recharge",
    "childcare": "Garde d’enfants",
    "cinema": "Cinéma",
    "clinic": "Clinique",
    "clock": "Horloge",
    "college": "Établissement d’enseignement supérieur",
    "community_centre": "Salle polyvalente",
    "courthouse": "Palais de justice",
    "crematorium": "Crématorium",
    "dentist": "Dentiste",
    "doctors": "Cabinet médical",
    "drinking_water": "Eau potable",
    "driving_school": "École de conduite",
    "embassy": "Ambassade",
    "fast_food": "Restauration rapide",
    "ferry_terminal": "Terminal de ferry",
    "fire_station": "Caserne des pompiers",
    "food_court": "Aire de restauration",
    "fountain": "Fontaine",
    "fuel": "Carburant",
    "gambling": "Jeu d’argent",
    "grave_yard": "Cimetière",
    "grit_bin": "Bac à sel",
    "hospital": "Hôpital",
    "hunting_stand": "Stand de tir",
    "ice_cream": "Glacier",
    "kindergarten": "Jardin d’enfant",
    "library": "Bibliothèque",
    "marketplace": "Marché",
    "monastery": "Monastère",
    "motorcycle_parking": "Parking à motos",
    "nightclub": "Boîte de nuit",
    "nursing_home": "Maison de retraite médicalisée",
    "office": "Bureau",
    "parking": "Parking",
    "parking_entrance": "Entrée d’un parking",
    "parking_space": "Place de parking",
    "pharmacy": "Pharmacie",
    "place_of_worship": "Lieu de culte",
    "police": "Police",
    "post_box": "Boîte aux lettres",
    "post_office": "Bureau de poste",
    "preschool": "Préscolaire",
    "prison": "Prison",
    "pub": "Pub",
    "public_building": "Bâtiment public",
    "recycling": "Point de recyclage",
    "restaurant": "Restaurant",
    "retirement_home": "Maison de retraite",
    "sauna": "Sauna",
    "school": "École",
    "shelter": "Abri",
    "shop": "Boutique",
    "shower": "Douche",
    "social_centre": "Centre social",
    "social_club": "Club social",
    "social_facility": "Service social",
    "studio": "Studio",
    "swimming_pool": "Piscine",
    "taxi": "Taxi",
    "telephone": "Téléphone public",
    "theatre": "Théâtre",
    "toilets": "Toilettes",
    "townhall": "Hôtel de ville / mairie",
    "university": "Université",
    "vending_machine": "Distributeur automatique",
    "veterinary": "Clinique vétérinaire",
    "village_hall": "Salle municipale",
    "waste_basket": "Poubelle",
    "waste_disposal": "Élimination des déchets",
    "water_point": "Point d’eau",
    "youth_centre": "Centre pour la jeunesse",
    "administrative": "Limite administrative",
    "census": "Frontière statistique",
    "national_park": "Parc national",
    "protected_area": "Zone protégée",
    "bridge": "Pont",
    "aqueduct": "Aqueduc",
    "boardwalk": "Promenade",
    "suspension": "Pont suspendu",
    "swing": "Pont tournant",
    "viaduct": "Viaduc",
    "building": "Bâtiment",
    "craft": "Boutique d’artisanat",
    "brewery": "Brasserie",
    "carpenter": "Charpentier",
    "electrician": "Électricien",
    "gardener": "Jardinier",
    "painter": "Peintre",
    "photographer": "Photographe",
    "plumber": "Plombier",
    "shoemaker": "Cordonnier",
    "tailor": "Tailleur",
    "emergency": "Urgence",
    "ambulance_station": "Dépôt d’ambulances",
    "assembly_point": "Point de rassemblement",
    "defibrillator": "Défibrillateur",
    "landing_site": "Terrain d’atterrissage d’urgence",
    "phone": "Borne d’appel d’urgence",
    "water_tank": "Citerne d’eau d’urgence",
    "highway": "Route",
    "abandoned": "Autoroute abandonnée",
    "bridleway": "Chemin pour cavaliers",
    "bus_guideway": "Voie de bus guidé / trolley",
    "bus_stop": "Arrêt de bus",
    "construction": "Route en construction",
    "corridor": "Couloir",
    "cycleway": "Piste cyclable",
    "elevator": "Ascenseur",
    "emergency_access_point": "Point d’accès d’urgence",
    "footway": "Chemin piéton",
    "ford": "Gué",
    "give_way": "Panneau « Cédez le passage »",
    "living_street": "Rue en zone de rencontre",
    "milestone": "Borne kilométrique",
    "motorway": "Autoroute",
    "motorway_junction": "Sortie / Échangeur",
    "motorway_link": "Bretelle d’autoroute",
    "passing_place": "Endroit de passage",
    "path": "Chemin",
    "pedestrian": "Rue piétonne",
    "platform": "Plateforme",
    "primary": "Route principale",
    "primary_link": "Route principale",
    "proposed": "Projet de route",
    "raceway": "Circuit",
    "residential": "Rue résidentielle",
    "rest_area": "Aire de repos",
    "road": "Route",
    "secondary": "Route secondaire",
    "secondary_link": "Route secondaire",
    "service": "Voie de service",
    "services": "Services autoroutiers",
    "speed_camera": "Radar de vitesse",
    "steps": "Escalier",
    "stop": "Panneau « Stop / Arrêt »",
    "street_lamp": "Lampadaire",
    "tertiary": "Route tertiaire",
    "tertiary_link": "Route tertiaire",
    "track": "Chemin",
    "traffic_signals": "Feux de circulation",
    "trail": "Sentier",
    "trunk": "Voie express",
    "trunk_link": "Voie express",
    "turning_loop": "Virage en boucle",
    "unclassified": "Route mineure",
    "historic": "Site / objet historique",
    "archaeological_site": "Site archéologique",
    "battlefield": "Champ de bataille",
    "boundary_stone": "Borne frontière",
    "building": "Bâtiment historique",
    "bunker": "Bunker",
    "castle": "Château",
    "church": "Église",
    "city_gate": "Porte de ville / porte fortifiée",
    "citywalls": "Remparts / murailles",
    "fort": "Fort",
    "heritage": "Site / objet du patrimoine",
    "house": "Maison historique",
    "icon": "Icône",
    "manor": "Manoir",
    "memorial": "Mémorial",
    "mine": "Mine",
    "mine_shaft": "Puits de mine",
    "monument": "Grand monument commémoratif",
    "roman_road": "Voie romaine",
    "ruins": "Ruines",
    "stone": "Pierre",
    "tomb": "Tombeau",
    "tower": "Tour",
    "wayside_cross": "Calvaire",
    "wayside_shrine": "Oratoire",
    "wreck": "Épave",
    "junction": "Intersection / carrefour",
    "landuse": "Utilisation des terres",
    "allotments": "Jardins familiaux",
    "basin": "Bassin",
    "brownfield": "Friche industrielle",
    "cemetery": "Cimetière",
    "commercial": "Zone tertiaire / Zone d’activités",
    "conservation": "Zone préservée",
    "construction": "Zone en construction",
    "farm": "Ferme",
    "farmland": "Terres agricoles",
    "farmyard": "Cour et corps de ferme",
    "forest": "Forêt",
    "garages": "Garages",
    "grass": "Pelouse",
    "greenfield": "Terrain vierge",
    "industrial": "Zone industrielle",
    "landfill": "Décharge",
    "meadow": "Prairie",
    "military": "Zone militaire",
    "mine": "Mine",
    "orchard": "Verger",
    "quarry": "Carrière",
    "railway": "Voie ferrée",
    "recreation_ground": "Aire de jeux",
    "reservoir": "Réservoir",
    "reservoir_watershed": "Bassin versant de réservoir",
    "residential": "Zone résidentielle",
    "retail": "Zone commerciale",
    "road": "Zone routière",
    "village_green": "Pré communal",
    "vineyard": "Vignoble",
    "leisure": "Loisirs",
    "beach_resort": "Station balnéaire",
    "bird_hide": "Observatoire ornithologique",
    "common": "Terrains communaux",
    "dog_park": "Parc à chiens",
    "firepit": "Foyer",
    "fishing": "Zone de pêche",
    "fitness_centre": "Centre de fitness",
    "fitness_station": "Atelier de parcours de santé",
    "garden": "Jardin",
    "golf_course": "Terrain de golf",
    "horse_riding": "Équitation",
    "ice_rink": "Patinoire",
    "marina": "Port de plaisance",
    "miniature_golf": "Mini golf",
    "nature_reserve": "Réserve naturelle",
    "park": "Parc",
    "pitch": "Terrain de sport",
    "playground": "Aire de jeux",
    "recreation_ground": "Terrain de jeux",
    "resort": "Villégiature",
    "sauna": "Sauna",
    "slipway": "Cale de lancement",
    "sports_centre": "Centre sportif",
    "stadium": "Stade",
    "swimming_pool": "Piscine",
    "track": "Piste de course",
    "water_park": "Parc aquatique",
    "man_made": "Créé par l’homme",
    "adit": "Galerie d’accès de mine",
    "beacon": "Balise",
    "beehive": "Ruche",
    "breakwater": "Brise-lames",
    "bridge": "Pont",
    "bunker_silo": "Bunker",
    "chimney": "Cheminée",
    "crane": "Grue",
    "dolphin": "Poste d’amarrage",
    "dyke": "Digue",
    "embankment": "Talus",
    "flagpole": "Mât de drapeau",
    "gasometer": "Gazomètre",
    "groyne": "Épi",
    "kiln": "Four",
    "lighthouse": "Phare",
    "mast": "Mât / pylône",
    "mine": "Mine",
    "mineshaft": "Puits de mine",
    "monitoring_station": "Station de surveillance",
    "petroleum_well": "Puits de pétrole",
    "pier": "Jetée",
    "pipeline": "Pipeline",
    "silo": "Silo",
    "storage_tank": "Citerne de stockage",
    "surveillance": "Dispositif / caméra de surveillance",
    "tower": "Tour",
    "wastewater_plant": "Station de traitement des eaux usées",
    "watermill": "Moulin à eau",
    "water_tower": "Château d’eau",
    "water_well": "Puits",
    "water_works": "Système hydraulique",
    "windmill": "Moulin à vent",
    "works": "Usine",
    "military": "Militaire",
    "airfield": "Terrain d’aviation militaire",
    "barracks": "Caserne",
    "bunker": "Bunker",
    "mountain_pass": "Col de montagne",
    "bay": "Baie",
    "beach": "Plage",
    "cape": "Cap",
    "cave_entrance": "Entrée de grotte",
    "cliff": "Falaise",
    "crater": "Cratère",
    "dune": "Dune",
    "fell": "Lande",
    "fjord": "Fjord",
    "forest": "Forêt",
    "geyser": "Geyser",
    "glacier": "Glacier",
    "grassland": "Herbage",
    "heath": "Bruyère",
    "hill": "Colline",
    "island": "Île",
    "land": "Terre",
    "marsh": "Marécage",
    "moor": "Brande",
    "mud": "Boue",
    "peak": "Pic",
    "point": "Pointe",
    "reef": "Récif",
    "ridge": "Crête",
    "rock": "Rocher",
    "saddle": "Selle",
    "sand": "Sable",
    "scree": "Éboulis",
    "scrub": "Broussailles",
    "spring": "Source",
    "stone": "Pierre",
    "strait": "Détroit",
    "tree": "Arbre",
    "valley": "Vallée",
    "volcano": "Volcan",
    "water": "Eau",
    "wetland": "Zone humide",
    "wood": "Forêt",
    "office": "Bureau",
    "accountant": "Comptable",
    "administrative": "Administration",
    "architect": "Architecte",
    "association": "Association",
    "company": "Entreprise",
    "educational_institution": "Institution éducative",
    "employment_agency": "Agence pour l’emploi",
    "estate_agent": "Agent immobilier",
    "government": "Administration publique",
    "insurance": "Agence d’assurance",
    "it": "Bureau informatique",
    "lawyer": "Avocat",
    "ngo": "Agence d’une ONG",
    "telecommunication": "Agence de télécommunication",
    "travel_agent": "Agence de voyage",
    "place": "Lieu",
    "allotments": "Jardins familiaux",
    "city": "Ville",
    "city_block": "Bloc urbain",
    "country": "Pays",
    "county": "Comté",
    "farm": "Ferme",
    "hamlet": "Hameau habité",
    "house": "Maison",
    "houses": "Maisons",
    "island": "Île",
    "islet": "Îlot",
    "isolated_dwelling": "Lieu-dit habité isolé",
    "locality": "Lieu-dit inhabité",
    "municipality": "Municipalité",
    "neighbourhood": "Quartier",
    "postcode": "Code postal",
    "quarter": "Quartier",
    "region": "Région",
    "sea": "Mer",
    "square": "Place",
    "state": "État / province",
    "subdivision": "Subdivision",
    "suburb": "Quartier",
    "town": "Ville",
    "unincorporated_area": "Territoire non organisé",
    "village": "Village",
    "abandoned": "Voie ferrée abandonnée",
    "construction": "Voie ferrée en construction",
    "disused": "Voie ferrée désaffectée",
    "funicular": "Funiculaire",
    "halt": "Arrêt de train",
    "junction": "Jonction ferroviaire",
    "level_crossing": "Passage à niveau",
    "light_rail": "Voie ferrée légère",
    "miniature": "Voie ferrée miniature",
    "monorail": "Monorail",
    "narrow_gauge": "Voie ferrée étroite",
    "platform": "Plateforme ferroviaire",
    "preserved": "Voie ferrée conservée",
    "proposed": "Voie ferrée en projet",
    "spur": "Embranchement ferroviaire",
    "station": "Gare ferroviaire",
    "stop": "Arrêt de chemin de fer",
    "subway": "Station de métro",
    "subway_entrance": "Bouche de métro",
    "switch": "Aiguillage",
    "tram": "Tramway",
    "tram_stop": "Arrêt de tram",
    "shop": "Boutique",
    "alcohol": "Vendeur d’alcool à emporter / caviste",
    "antiques": "Antiquaire",
    "art": "Boutique d’art",
    "bakery": "Boulangerie",
    "beauty": "Magasin de produits de beauté",
    "beverages": "Magasin de boissons",
    "bicycle": "Magasin de vélos",
    "bookmaker": "Bureau de paris",
    "books": "Librairie",
    "boutique": "Boutique de mode",
    "butcher": "Boucherie",
    "car": "Concession automobile",
    "car_parts": "Pièces d’automobile",
    "car_repair": "Garage de réparation automobile",
    "carpet": "Magasin de tapis",
    "charity": "Boutique humanitaire",
    "chemist": "Droguerie",
    "clothes": "Boutique de vêtements",
    "computer": "Boutique informatique",
    "confectionery": "Confiserie",
    "convenience": "Épicerie",
    "copyshop": "Boutique de photocopies",
    "cosmetics": "Boutique de cosmétiques",
    "deli": "Traiteur",
    "department_store": "Grand magasin",
    "discount": "Magasin discount",
    "doityourself": "Magasin de bricolage",
    "dry_cleaning": "Pressing de nettoyage à sec",
    "electronics": "Boutique de produits électroniques",
    "estate_agent": "Agent immobilier",
    "farm": "Magasin de produits agricoles",
    "fashion": "Boutique de mode",
    "fish": "Poissonnerie",
    "florist": "Fleuriste",
    "food": "Magasin d’alimentation",
    "funeral_directors": "Pompes funèbres",
    "furniture": "Magasin de meubles",
    "gallery": "Galerie",
    "garden_centre": "Jardinerie",
    "general": "Magasin généraliste",
    "gift": "Boutique de cadeaux",
    "greengrocer": "Marchand de fruits et légumes",
    "grocery": "Épicerie",
    "hairdresser": "Coiffeur",
    "hardware": "Quincaillerie",
    "hifi": "Magasin Hi-Fi",
    "houseware": "Magasin d’articles ménagers",
    "interior_decoration": "Décoration intérieure",
    "jewelry": "Bijouterie",
    "kiosk": "Kiosque",
    "kitchen": "Magasin de cuisine",
    "laundry": "Blanchisserie",
    "lottery": "Loterie",
    "mall": "Centre commercial",
    "market": "Marché",
    "massage": "Massage",
    "mobile_phone": "Boutique de téléphones mobiles",
    "motorcycle": "Magasin de motos",
    "music": "Boutique de musique / disquaire",
    "newsagent": "Marchand de journaux",
    "optician": "Opticien",
    "organic": "Magasin d’alimentation bio",
    "outdoor": "Magasin d’articles pour activité en plein air",
    "paint": "Galerie de peinture",
    "pawnbroker": "Prêteur sur gages",
    "pet": "Animalerie",
    "pharmacy": "Pharmacie",
    "photo": "Boutique de photographie",
    "seafood": "Fruits de mer",
    "second_hand": "Boutique de produits d’occasion",
    "shoes": "Magasin de chaussures",
    "sports": "Magasin de d’articles de sport",
    "stationery": "Papeterie",
    "supermarket": "Supermarché",
    "tailor": "Tailleur",
    "ticket": "Billetterie",
    "tobacco": "Bureau de tabac",
    "toys": "Magasin de jouets",
    "travel_agency": "Agence de voyage",
    "tyres": "Magasin de pneus",
    "vacant": "Commerce vacant",
    "variety_store": "Magasin à prix unique ou réduit",
    "video": "Magasin de vidéos",
    "wine": "Caviste",
    "alpine_hut": "Refuge",
    "apartment": "Appartement de vacances",
    "artwork": "Œuvre d’art",
    "attraction": "Attraction",
    "bed_and_breakfast": "Gîte",
    "cabin": "Hutte",
    "camp_site": "Camping",
    "caravan_site": "Site pour caravanes",
    "chalet": "Chalet",
    "gallery": "Galerie",
    "guest_house": "Maison d’hôte",
    "hostel": "Auberge",
    "hotel": "Hôtel",
    "information": "Informations",
    "motel": "Motel",
    "museum": "Musée",
    "picnic_site": "Aire de pique-nique",
    "theme_park": "Parc à thème",
    "viewpoint": "Point de vue",
    "zoo": "Zoo",
    "tunnel": "Tunnel",
    "building_passage": "Passage de bâtiment",
    "culvert": "Buse",
    "waterway": "Cours d’eau",
    "artificial": "Cours d’eau artificiel",
    "boatyard": "Chantier naval",
    "canal": "Canal",
    "dam": "Barrage",
    "derelict_canal": "Canal d’évacuation",
    "ditch": "Fossé",
    "dock": "Dock",
    "drain": "Drain",
    "lock": "Écluse",
    "lock_gate": "Porte d’écluse",
    "mooring": "Mouillage",
    "rapids": "Rapides",
    "river": "Rivière",
    "stream": "Ruisseau",
    "wadi": "Oued",
    "waterfall": "Chute d’eau",
    "weir": "Barrage",
};

export function translateOSMKey(key, language = 'fr') {
    return translations[key] || null;
}
